import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BusinessLoanComponent } from './business-loan/business-loan.component';
import { AuthGuard } from '../login/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: BusinessLoanComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'step-one',
        loadChildren: () => import('../step-one/step-one.module').then((m) => m.StepOneModule),
      },
      {
        path: 'step-two',
        loadChildren: () => import('../step-two/step-two.module').then((m) => m.StepTwoModule),
      },
      {
        path: 'step-three',
        loadChildren: () => import('../step-three/step-three.module').then((m) => m.StepThreeModule),
      },
      {
        path: 'step-four',
        loadChildren: () => import('../step-four/step-four.module').then((m) => m.StepFourModule),
      },
      {
        path: 'step-five',
        loadChildren: () => import('../step-five/step-five.module').then((m) => m.StepFiveModule),
      },
      {
        path: 'step-six',
        loadChildren: () => import('../step-six/step-six.module').then((m) => m.StepSixModule),
      },
      {
        path: 'step-seven',
        loadChildren: () => import('../step-seven/step-seven.module').then((m) => m.StepSevenModule),
      },
    ],
  },
  {
    path: 'success',
    loadChildren: () => import('../success/success.module').then((m) => m.SuccessModule),
  },
  {
    path: 'application-list',
    loadChildren: () => import('../application-list/application-list.module').then((m) => m.ApplicationListModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BusinessLoanRoutingModule { }
